export default __webpack_public_path__ + "static/media/logo.938ec6c8.png";